import { loadCompositionEstimates } from "components/jiffy/products/product-composition-estimates";
import initJiffyMadeUpsellCard from "./jiffy-made-upsell-card/jiffy-made-upsell-card";

import "./product-details-upsell-section.scss";
import "./product-card-overrides.scss";

const $getUpsellSection = () => document.querySelector(".js-product-details-upsell-section");
const $getUpsellCards = () => {
  const $upsellSection = $getUpsellSection();
  return $upsellSection?.querySelectorAll(".js-product-card") || [];
};

const loadUpsellCompositionDeliveryDates = () => {
  const $cards = $getUpsellCards();
  const cardsArray = Array.from($cards);
  const compositionIds = cardsArray.map($card => $card.dataset.compositionId);
  const businessLine = cardsArray.find($card => $card.dataset.businessLine)?.dataset.businessLine;

  if (compositionIds.length) {
    loadCompositionEstimates(compositionIds, {
      isSendIndividually: !window.jiffy?.flip?.fastDeliveryEstimate,
      businessLine
    });
  }
};

const init = () => {
  loadUpsellCompositionDeliveryDates();
  initJiffyMadeUpsellCard();
};

export default init;
